import { useEffect } from 'react';

// 値はあるのに候補が空の親の値を見つけて取得し直す。
// 候補は行番号ではなく親の値（言語名など）をキーに保持するので、行の削除・並び替えに影響されない。
// validParentNames（マスタデータ一覧）を渡すと、実在する値のときだけ復元する
// （手入力の途中経過ごとに通信が飛ぶのを防ぐため）。未指定なら絞り込みなし。
export function useRestoreChildOptions(items, getParentName, options, setOptions, fetchChildData, validParentNames) {
  const parentNames = [...new Set(items.map(getParentName).filter(Boolean))];
  const parentNamesKey = JSON.stringify(parentNames);

  const validNamesList = validParentNames
    ? validParentNames.map((v) => (typeof v === 'string' ? v : v.name))
    : null;
  const validNamesKey = validNamesList ? validNamesList.join(' ') : '';

  useEffect(() => {
    // マスタデータ読み込み待ち。読み込み完了でvalidNamesKeyが変わり再実行される
    if (validNamesList && validNamesList.length === 0) return;

    const validNames = validNamesList ? new Set(validNamesList) : null;
    parentNames.forEach((parentName) => {
      if (validNames && !validNames.has(parentName)) return;
      if (options[parentName]) return;

      fetchChildData(parentName)
        .then((data) => setOptions((prev) => ({ ...prev, [parentName]: data })))
        .catch((error) => console.error('Error restoring child options:', error));
    });
  }, [parentNamesKey, validNamesKey]);
}
